import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { useTimeStore } from './time';
export var useSubscriptionStore = defineStore({
  id: 'subscription',
  state: function state() {
    return {
      token: null,
      access: null,
      subscription: null,
      subscribed: false,
      hadAccess: false,
      trialAvailable: false,
      hydrated: false
    };
  },
  getters: {
    trialVisible: function trialVisible(state) {
      var time = useTimeStore();
      var tokenExpired = !state.token;
      if (state.token && state.token.end) {
        tokenExpired = new Date(state.token.end) < time.now;
      }
      return state.trialAvailable && tokenExpired;
    },
    expired: function expired(state) {
      var time = useTimeStore();
      if (!state.token || !state.token.end) return false;
      return new Date(state.token.end) < time.now;
    }
  },
  actions: {
    hydrate: function hydrate() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$nuxt.$axios.$get('/access/checkstatus/', {
                progress: false
              }).catch(function (err) {
                console.log(err);
                _this.hydrating = false;
              });
            case 2:
              data = _context.sent;
              if (data !== null && data !== void 0 && data.token) _this.token = data.token;
              if (data !== null && data !== void 0 && data.payment) {
                _this.subscribed = data.payment.status == 'subscribed';
              } else {
                _this.subscribed = false;
              }
              if (data && 'hadAccess' in data) {
                _this.hadAccess = data.hadAccess;
              }
              if (data && 'trialAvailable' in data) {
                _this.trialAvailable = data.trialAvailable;
              }
              if (data && 'access' in data) {
                _this.access = data.access;
              }
              _this.hydrated = true;
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    setToken: function setToken(token) {
      this.token = token;
      this.subscription = token.access;
    }
  }
});